
import React from 'react';
import { ArrowRight } from 'lucide-react';

const ResultatsSection = () => {
  const resultats = [
    {
      titre: "Startup FinTech",
      description: "Stratégie LinkedIn pour levée de fonds",
      metrics: [
        { label: "Followers", avant: "500", apres: "5.2K", evolution: "+940%" },
        { label: "Engagement", avant: "2%", apres: "8.5%", evolution: "+325%" },
        { label: "Leads qualifiés", avant: "5/mois", apres: "45/mois", evolution: "+800%" }
      ]
    },
    {
      titre: "E-commerce Mode",
      description: "Campagne Instagram Shopping",
      metrics: [
        { label: "Reach", avant: "2K", apres: "25K", evolution: "+1150%" },
        { label: "Conversions", avant: "1.2%", apres: "4.8%", evolution: "+300%" },
        { label: "ROI publicitaire", avant: "2.5x", apres: "6.2x", evolution: "+148%" }
      ]
    }
  ];

  return (
    <section className="py-20">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-light text-navy-900 mb-6">
              Résultats <span className="font-semibold text-blue-600">concrets</span>
            </h2>
            <p className="text-lg text-navy-600 font-light max-w-2xl mx-auto">
              Des performances mesurables qui parlent d'elles-mêmes
            </p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-12">
            {resultats.map((resultat, index) => (
              <div key={index} className="bg-white border border-navy-100 p-8 shadow-lg">
                <h3 className="text-2xl font-semibold text-navy-900 mb-2">{resultat.titre}</h3>
                <p className="text-navy-600 font-light mb-8">{resultat.description}</p>
                
                <div className="space-y-6">
                  {resultat.metrics.map((metric, metricIndex) => (
                    <div key={metricIndex} className="flex items-center justify-between">
                      <span className="text-navy-700 font-medium">{metric.label}</span>
                      <div className="flex items-center gap-4">
                        <span className="text-sm text-navy-500">{metric.avant}</span>
                        <ArrowRight className="text-blue-600" size={16} />
                        <span className="font-semibold text-navy-900">{metric.apres}</span>
                        <span className="bg-green-100 text-green-700 px-2 py-1 text-xs font-medium">
                          {metric.evolution}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResultatsSection;
